import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class DownloadTransactionPDFCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transactionID: string, bankAccountID: string): Promise<any> {
    let args = { 
      transaction_id: transactionID,
      bank_account_id: bankAccountID,
    }
    try {
      let res = await this.dispatcher.dispatch('download.transaction.pdf', args)
      // Primero establecer el job_id, luego el estado para evitar race condition
      this.frontend.$set(this.frontend.downloadPDFJobIds, transactionID, res.job_id);
      // Usar $nextTick para asegurar que el job_id esté disponible cuando cambie el estado
      this.frontend.$nextTick(() => {
        this.frontend.$set(this.frontend.downloadPDFJobStates, transactionID, 'running');
      });
    } catch (error) {
      console.error('Error download pdf transaction', error)
    }
  }
}